export default "__VITE_ASSET___HBfINMz__";